import { supabase } from "../integrations/supabase/client";

/**
 * Get the current authenticated user
 */
export async function getCurrentUser() {
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession();

  if (error) {
    console.error("Error getting current session:", error);
    return null;
  }

  return session?.user || null;
}

/**
 * Sign out the current user
 */
export async function signOut() {
  const { error } = await supabase.auth.signOut();

  if (error) {
    console.error("Error signing out:", error);
    throw error;
  }

  return true;
}
